<template>
    <div class="row">
        <div md="12" lg="10" class="d-flex align-items-center col-ms-12">
            <div @click="showModal" class="gemo_box d-flex align-items-center">
                <picture>
                    <source width="25" height="25" type="image/webp" srcset="~/assets/assets/gemologist.webp">
                    <img width="25" height="25" loading="lazy" type="image/jpeg" alt="Get a gemologist opinion" src="~/assets/assets/gemologist.jpg">
                </picture>
                <span class="ms-3">Gemologist's Opinion</span>
            </div>
        </div>
       
        <CommonCustomModal v-model="flagShowModal" :size="'sm'">
            <GemologistForm :data="props.data" @hideModal="hideModal" />
        </CommonCustomModal>
    </div>
</template>

<script setup>

    const props = defineProps(['data'])
    const flagShowModal = ref(false);
    const gemoref = ref(null);
  
    const showModal = () => {
        flagShowModal.value = true;
    };


    const hideModal = () => {
        flagShowModal.value = false;
    };

</script>

<style scoped>
    
    input{
        border-radius: 4px;
        font-size: 16px;
    }
    textarea {
        border-radius: 4px;
        font-size: 16px;
    }
    .modal-content{
        padding: 2%;
        border-radius: 8px;
    }
    .checkbox_custom {
        font-size: 14px;
        font-weight: 600;
    }
    span{
        color: #363030;
        font-size: 14px;
        font-weight: 600;
    }
    .gemo_box{
        cursor: pointer;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        width: 100%;
        padding: 13px 15px;
        height: 50px;
    }
    .gemo_box img {
        border-radius: 50%;
    }
    .title_block{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .title_block span {
        cursor: pointer;
    }
    .title_block h5 {
        font-size: 20px;
    }
    p{
        font-size: 16px;
        margin-bottom: 0;
        padding-top: 9px;
        color: #606060;
    }

    .largesvg {
        transform: scale(1.3);
    }

    @media(max-width: 767px){
        p br{
            display: none;
        }
    }
</style>
